import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import { Types as TypesInformation } from '../../getProcedureInformation/actions';
import ReincorporationRepository from '../../../../repositories/ReincorporationRepository';
import ReincorporationDataRepository from '../../../../../data/repositories/ReincorporationDataRepository';

export default function* execute(action: any): any {
  try {
    const {
      procedureId,
      newPeriod,
      requiresPayment,
      campusId,
      careerId,
      modalityId,
      newCampusId,
      newCampusDescription,
      newCareerId,
      newCareerDescription,
      newModalityId,
      newModalityDescription,
      reincorporationType,
      academicPlan,
      newAcadCareer,
      codProgCM,
      codPlanCM,
      acadCareerCM
    } = action.data;

    yield put({ type: Types.REGISTER_REINCORPORATION_REQUEST });
    const reincorporationRepository: ReincorporationRepository =
      new ReincorporationDataRepository();

    const registerReincorporationResponse = yield call(
      reincorporationRepository.registerReincorporation,
      {
        procedureId,
        requiresPayment,
        newPeriod,
        campusId,
        careerId,
        modalityId,
        newCampusId,
        newCampusDescription,
        newCareerId,
        newCareerDescription,
        newModalityId,
        newModalityDescription,
        reincorporationType,
        academicPlan,
        newAcadCareer,
        codProgCM,
        codPlanCM,
        acadCareerCM
      }
    );

    if (
      !registerReincorporationResponse ||
      registerReincorporationResponse?.error
    ) {
      yield put({
        type: Types.REGISTER_REINCORPORATION_FAILURE,
        error: 'No se pudo registrar'
      });
      return;
    }

    yield put({
      type: TypesInformation.GET_PROCEDURE_INFORMATION_CLEAR
    });

    yield put({
      type: Types.REGISTER_REINCORPORATION_SUCCESS,
      data: registerReincorporationResponse.requestId
    });
  } catch (error) {
    yield put({
      type: Types.REGISTER_REINCORPORATION_FAILURE,
      error:
        'Ocurrió un error al momento de registrar los datos del trámite solicitado.'
    });
  }
}
